import { body } from "../constants";
export default (elem) => elem && body.contains(elem);
